<template>
  <div class="content-management">
    <el-row :gutter="40">
      <el-col :span="8">
        <h2 class="content-management-title">栏目管理</h2>
        <div class="content-management-btns">
          <el-button type="primary" :size="$store.state.buttonSize" @click="columnPopup()">新增栏目</el-button>
          <el-button type="info" :disabled="delDisabled" :size="$store.state.buttonSize" @click="delColumnList">批量删除</el-button>
        </div>
        <el-tree
          :data="columnData"
          show-checkbox
          node-key="id"
          ref="columnTree"
          @check="columnCheckList"
          default-expand-all
          :expand-on-click-node="false"
          :render-content="renderContent">
        </el-tree>
      </el-col>
      <el-col :span="16" style="border-left: solid 1px #f5f5f5;">
        <h2 class="content-management-title">文章管理</h2>
        <div class="tabel-bar">
          <div class="tabel-bar-left">
            <el-button type="primary" :size="$store.state.buttonSize" @click="newsPopup()"
              >新增文章</el-button
            >
            <RemoveButton
              type="info"
              @click="deleteNewsList"
              :disabled="!selectionID.length"
            >批量删除</RemoveButton>
          </div>
          <div class="tabel-bar-right">
            <el-input
              placeholder="请输入内容"
              :size="$store.state.formSize"
              prefix-icon="el-icon-search"
              v-model="keywords"
              @input="searchNews"
            ></el-input>
            <el-tooltip effect="dark" content="刷新列表" placement="bottom">
              <span
                class="el-icon-refresh icon-hover refresh-btn"
                @click="debounceRefresh"
              ></span>
            </el-tooltip>
          </div>
        </div>
        <el-table v-loading="loading" :data="newsData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column prop="shortTitle" label="短标题"> </el-table-column>
          <el-table-column prop="author" label="作者"> </el-table-column>
          <el-table-column prop="source" label="来源"> </el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.state === 1" type="warning">未发布</el-tag>
              <el-tag v-else-if="scope.row.state === 2">已发布</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <template v-if="scope.row.state === 1">
                <el-button type="text" @click="newsPublish(scope.row.id)"
                  >发布</el-button
                >
              </template>
              <el-button type="text" @click="newsPopup(scope.row.id)"
                >编辑</el-button
              >
              <el-button type="text" @click="removeNews(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="size"
          :total="total"
        >
        </pagination>
      </el-col>
    </el-row>
    <!-- 栏目表单 -->
    <Dialog :title="columnTitle" width="40%" :visible.sync="columnVisible" center>
      <el-form
        :model="columnForm"
        :size="$store.state.formSize"
        :rules="columnFormRules"
        ref="refColumnForm"
        label-width="100px"
      >
        <el-form-item label="栏目编码：" prop="channelCode">
          <el-input v-model="columnForm.channelCode" :disabled="columnDisabled"></el-input>
        </el-form-item>
        <el-form-item label="栏目名称：" prop="channelName">
          <el-input v-model="columnForm.channelName"></el-input>
        </el-form-item>
        <el-form-item label="是否导航：" prop="isNavigation">
          <el-radio-group v-model="columnForm.isNavigation">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="栏目地址：">
          <el-input v-model="columnForm.url"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;" >
        <el-button type="primary" :disabled="isDisabled" @click="debounceColumnSubmit" :size="$store.state.buttenSize">确 定</el-button>
        <el-button :size="$store.state.buttenSize" @click="hanleResetColumnForm">取 消</el-button>
      </div>
    </Dialog>
    <!-- 栏目表单 -->
    <Dialog :title="newsTitle" width="70%" :visible.sync="newsVisible" center>
      <el-form
        :model="newsForm"
        :size="$store.state.formSize"
        :rules="newsFormRules"
        ref="refNewsForm"
        label-width="100px"
      >
        <el-form-item label="所属栏目：" prop="channelId">
          <el-select v-model="newsForm.channelId" style="width:100%" placeholder="请选择">
            <el-option
              v-for="item in columnData"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题：" prop="title">
          <el-input v-model="newsForm.title"></el-input>
        </el-form-item>
        <el-form-item label="短标题：">
          <el-input v-model="newsForm.shortTitle"></el-input>
        </el-form-item>
        <el-form-item label="作者：">
          <el-input v-model="newsForm.author"></el-input>
        </el-form-item>
        <el-form-item label="来源：">
          <el-input v-model="newsForm.source"></el-input>
        </el-form-item>
        <el-form-item label="图片：">
          <el-upload
          action="#"
          list-type="picture-card"
          :limit="parseInt('1')"
          :http-request="handleHttpRequest"
          :before-upload="beforeAvatarUpload"
          :on-change="uploadChange"
          :on-remove="uploadRemove"
          :class="{hide:hideUpload}"
          ref="upload"
          :file-list="initFile">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail" :src="newsForm.imgUrl"
              >
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <Dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </Dialog>
        </el-form-item>
        <el-form-item label="摘要：">
          <el-input type="textarea" v-model="newsForm.description" rows="3"></el-input>
        </el-form-item>
        <el-form-item label="内容：">
          <vue-ueditor-wrap v-model="newsForm.content" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;" >
        <el-button type="primary" :disabled="isDisabled" @click="debounceNewsSubmit" :size="$store.state.buttenSize">确 定</el-button>
        <el-button :size="$store.state.buttenSize" @click="hanleResetNewsForm">取 消</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { postWfsImg, wfsImgUrl } from '@/api/common'
import VueUeditorWrap from 'vue-ueditor-wrap'
import { debounce } from 'throttle-debounce'
import { putChannelAdd, getChannelList, postChannelEdit, getChannelDetail, deleteChannelDel, delChannelList } from '@/api/channel'
import { putNewsAdd, getNewsList, postNewsEdit, getNewsDetail, delNewsList, deleteNewsDel, postNewsPublish } from '@/api/news'
const createColumnForm = () => ({
  channelCode: '',
  channelName: '',
  isNavigation: '1',
  url: '',
  imgUrl: '',
  id: undefined
})
const creatNewsForm = () => ({
  author: '',
  channelId: null,
  content: '',
  description: '',
  img: '',
  shortTitle: '',
  source: '',
  title: '',
  id: undefined
})
export default {
  components: { VueUeditorWrap },
  data() {
    return {
      columnVisible: false,
      columnForm: createColumnForm(),
      isDisabled: false,
      columnID: null,
      delDisabled: true,
      columnDisabled: false,
      selectionID: [],
      keywords: '',
      page: 1,
      size: 10,
      total: 0,
      loading: true,
      newsVisible: false,
      newsForm: creatNewsForm(),
      newsID: null,
      newsData: [],
      initFile: [],
      disabled: false,
      dialogImageUrl: '',
      hideUpload: false,
      dialogVisible: false,
      limitCount: 1,
      columnFormRules: {
        channelCode: [
          { required: true, message: '请输入栏目编码', trigger: 'blur' }
        ],
        channelName: [
          { required: true, message: '请输入栏目名称', trigger: 'blur' }
        ],
        isNavigation: [
          { required: true, message: '请选择是否导航', trigger: 'blur' }
        ]
      },
      newsFormRules: {
        channelId: [
          { required: true, message: '请选择所属栏目', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ]
      },
      columnData: [],
      channelId: null,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 层级设置，解决在弹出窗口中下拉菜单被遮罩问题
        zIndex: 10000,
        // 上传文件接口（WFS）
        serverUrl: `${process.env.VUE_APP_BASE_API}/trace/wfs/ueditor`,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  computed: {
    columnTitle() {
      return this.columnID ? '编辑栏目' : '新增栏目'
    },
    newsTitle() {
      return this.newsID ? '编辑文章' : '新增文章'
    }
  },
  created() {
    this.debounceColumnSubmit = debounce(300, this.columnSubmit)
    this.debounceNewsSubmit = debounce(300, this.newsSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleHttpRequest(option) {
      const formData = new FormData()
      if (option.data) {
        Object.keys(option.data).forEach(key => {
          formData.append(key, option.data[key])
        })
      }
      formData.append(option.filename, option.file)
      postWfsImg(formData).then(res => {
        if (res.status === 1) {
          this.newsForm.img = res.data.filePath
          this.newsForm.imgUrl = wfsImgUrl(res.data.filePath)
          this.initFile.push({ name: 1, url: wfsImgUrl(res.data.filePath) })
        } else {
          this.$message.error(res.msg || '图片上传失败')
        }
      }).catch(() => {
        this.$message.error('图片上传失败')
      })
    },
    uploadChange(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    uploadRemove(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    handleRemove(file) {
      this.newsForm.imgUrl = ''
      this.newsForm.img = ''
      this.initFile = []
      this.$refs.upload.handleRemove(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isType = /^image\/(jpeg|png|jpg|bmp)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isType) {
        this.$message.error('请选择图片文件进行上传!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isType && isLt2M
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getMaterialuseinfoListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getMaterialuseinfoListData()
    },
    removeColumn(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteChannelDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除成功')
              this.getColumnListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    removeNews(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteNewsDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除成功')
              this.getNewsListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    newsPublish(id) {
      postNewsPublish(id).then(res => {
        if (res.status === 1) {
          this.getNewsListData()
          this.$message.success('发布成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span on-click={ () => this.showNewsListData(data) }>{node.label}</span>
          <span>
            <el-button size="mini" type="text" on-click={ () => this.columnPopup(data.id) }>编辑</el-button>
            <el-button size="mini" type="text" on-click={ () => this.removeColumn(data.id) }>删除</el-button>
          </span>
        </span>)
    },
    showNewsListData(data) {
      this.channelId = data.id
      this.channelCode = data.channelCode
      this.getNewsListData()
    },
    columnCheckList() {
      if (this.$refs.columnTree.getCheckedKeys().length > 0) this.delDisabled = false
    },
    delColumnList() {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delChannelList(this.$refs.columnTree.getCheckedKeys()).then(res => {
            if (res.status === 1) {
              this.$message.success('删除成功')
              this.getColumnListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 打开新增/编辑栏目窗口
    columnPopup(id) {
      this.columnVisible = true
      const isAdd = !id
      this.$set(this, 'columnForm', createColumnForm())
      if (isAdd) {
        this.columnDisabled = false
        this.columnID = null
      } else {
        this.columnID = id
        this.columnDisabled = true
        getChannelDetail(id).then(res => {
          this.columnForm.id = res.data.id
          this.columnForm.channelCode = res.data.channelCode
          this.columnForm.channelName = res.data.channelName
          this.columnForm.isNavigation = res.data.isNavigation
          this.columnForm.url = res.data.url
        })
      }
    },
    // 打开新闻表单窗口
    newsPopup(id) {
      this.initFile = []
      this.hideUpload = false
      this.newsVisible = true
      const isAdd = !id
      this.$set(this, 'newsForm', creatNewsForm())
      if (isAdd) {
        this.newsID = null
        this.newsForm.channelId = this.channelId
      } else {
        this.newsID = id
        getNewsDetail(id).then(res => {
          console.log(res)
          this.newsForm.id = res.data.id
          this.newsForm.channelId = res.data.channelId
          this.newsForm.author = res.data.author
          this.newsForm.content = res.data.content
          this.newsForm.description = res.data.description
          this.newsForm.img = res.data.img
          if (res.data.imgUrl) {
            this.newsForm.imgUrl = res.data.imgUrl
            this.initFile.push({ name: 1, url: res.data.imgUrl })
            this.hideUpload = true
          } else {
            this.hideUpload = false
          }
          this.newsForm.shortTitle = res.data.shortTitle
          this.newsForm.source = res.data.source
          this.newsForm.title = res.data.title
        })
      }
    },
    // 关闭栏目表单
    hanleResetColumnForm() {
      this.columnVisible = false
      this.$set(this, 'columnForm', createColumnForm())
    },
    // 关闭新闻表单
    hanleResetNewsForm() {
      this.newsVisible = false
      this.$set(this, 'newsForm', creatNewsForm())
    },
    // 新增/编辑栏目
    columnSubmit() {
      this.$refs.refColumnForm.validate(valid => {
        if (!valid) return false
        const submitChange = this.columnID ? postChannelEdit : putChannelAdd
        this.columnForm.id = this.columnID || undefined
        submitChange(this.columnForm).then(res => {
          if (res.status === 1) {
            this.columnVisible = false
            this.columnID ? this.$message.success('编辑成功') : this.$message.success('新增成功')
            this.getColumnListData()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // 新增/编辑文章
    newsSubmit() {
      this.$refs.refNewsForm.validate(valid => {
        if (!valid) return false
        const submitChange = this.newsID ? postNewsEdit : putNewsAdd
        this.newsForm.id = this.newsID || undefined
        submitChange(this.newsForm).then(res => {
          if (res.status === 1) {
            this.newsVisible = false
            this.newsID ? this.$message.success('编辑成功') : this.$message.success('新增成功')
            this.getNewsListData()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // 获取栏目列表
    getColumnListData() {
      getChannelList({
        page: 1,
        size: 100
      }).then(res => {
        const result = []
        res.data.rows.map(item => {
          result.push({
            id: item.id,
            label: item.channelName,
            channelCode: item.channelCode
          })
        })
        this.columnData = result
      })
    },
    // 获取新闻列表
    getNewsListData() {
      this.loading = true
      getNewsList({
        page: this.page,
        size: this.size,
        channelCode: this.channelCode,
        title: this.keywords
      }).then(res => {
        this.total = res.data.total
        if (res.status === 1) {
          this.newsData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    deleteNewsList() {
      delNewsList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getNewsListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 刷新数据表格
    refresh() {
      this.getNewsListData()
      this.$message.success('数据刷新成功')
    },
    // 检索
    searchNews() {
      this.getNewsListData()
    }
  },
  mounted() {
    this.getColumnListData()
    this.getNewsListData()
  }
}
</script>

<style lang="scss">
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 10px;
  }
  .content-management-title {
    padding-bottom: 20px;
  }
  .content-management-btns {
    padding-bottom: 20px;
  }
</style>
<style lang="scss">
.hide .el-upload--picture-card {
    display: none;
}
</style>
